module.exports = __webpack_public_path__ + "img/img_data.d9041caf.jpg";